function HomeDayModal({
  isOpen,
  modalOverlayStyle,
  modalContentStyle,
  selectedHomeDay,
  orderedHomeMeals,
  homeMealIndex,
  dragOffset,
  closeRecipeModal,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
  closeButtonStyle,
  hoveredButton,
  setHoveredButton,
  activeModalRecipe,
  activeModalMealType,
  appTheme,
  isCompletedMeal,
  isMobile,
  secondaryButtonStyle,
  primaryButtonStyle,
  goToHomeViewerMeal,
  handleChooseRecipeFromHomeModal,
  handleQuickAddFromHomeModal,
  setActiveTab,
  setRecipeSearch,
  setSelectedRecipe,
  setSelectedHomeDay,
  setHomeMealIndex,
  isDraggingRef,
  setDragOffset,
  completeMeal,
  completedMeals,
  getDateKey
}) {
  if (!isOpen) return null;

  return (
    <div
      style={modalOverlayStyle}
      onClick={closeRecipeModal}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-scroll-hidden"
          style={{
            ...modalContentStyle,
            maxWidth: isMobile ? "94vw" : "760px",
            width: "100%",
            padding: "0",
            maxHeight: isMobile ? "84vh" : "calc(100vh - 40px)",
            overflowY: "auto",
            overflowX: "hidden",
            margin: "0 auto",
            overscrollBehavior: "contain"
          }}
        >
          <div
            style={{
              overflow: "hidden",
              width: "100%"
            }}
          >
            <div
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseUp}
              style={{
                display: "flex",
                width: `${orderedHomeMeals.length * 100}%`,
                transform: `translateX(calc(-${
                  homeMealIndex * (100 / orderedHomeMeals.length)
                }% + ${dragOffset}px))`,
                transition: isDraggingRef.current
                  ? "none"
                  : "transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)",
                touchAction: "pan-y",
                cursor: "grab",
                WebkitUserSelect: "none",
                userSelect: "none"
              }}
            >
              {orderedHomeMeals.map((item) => {
                const meal = item.meal;
                const mealType = item.mealType;
                const isCompleted = item.isCompleted;

                return (
                  <div
                    key={`${selectedHomeDay}-${mealType}`}
                    style={{
                      width: `${100 / orderedHomeMeals.length}%`,
                      flexShrink: 0,
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column"
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        height: isMobile ? "220px" : "250px",
                        backgroundImage: meal?.image
                          ? `linear-gradient(to top, rgba(15, 23, 42, 0.82), rgba(15, 23, 42, 0.18)), url(${meal.image})`
                          : "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        display: "flex",
                        alignItems: "flex-end"
                      }}
                    >
                      <button
                        onClick={closeRecipeModal}
                        style={{
                          ...closeButtonStyle(hoveredButton, "modal-close", appTheme),
                          position: "absolute",
                          top: "18px",
                          right: "18px",
                          background: "rgba(255,255,255,0.86)",
                          backdropFilter: "blur(10px)"
                        }}
                      >
                        ×
                      </button>

                      <div
                        style={{
                          width: "100%",
                          padding: isMobile ? "16px" : "22px",
                          color: meal?.image ? "#ffffff" : appTheme.primaryText
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                            marginBottom: "10px"
                          }}
                        >
                          <span
                            style={{
                              background: meal?.image
                                ? "rgba(255,255,255,0.16)"
                                : appTheme.softBackground,
                              padding: "7px 12px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              backdropFilter: "blur(6px)",
                              textTransform: "capitalize",
                              color: meal?.image ? "#ffffff" : appTheme.primaryText
                            }}
                          >
                            {mealType}
                          </span>

                          <span
                            style={{
                              background: isCompleted
                                ? "rgba(22,163,74,0.88)"
                                : meal?.image
                                ? "rgba(255,255,255,0.16)"
                                : appTheme.softBackground,
                              padding: "7px 12px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              backdropFilter: "blur(6px)",
                              color: isCompleted
                                ? "#ffffff"
                                : meal?.image
                                ? "#ffffff"
                                : appTheme.primaryText
                            }}
                          >
                            {isCompleted ? "Completed" : selectedHomeDay}
                          </span>
                        </div>

                        <h2
                          style={{
                            margin: 0,
                            fontSize: isMobile ? "24px" : "30px",
                            fontWeight: "500",
                            lineHeight: 1.15,
                            marginBottom: "12px",
                            fontFamily: appTheme.fontBody
                          }}
                        >
                          {meal?.name || `Add ${mealType}`}
                        </h2>

                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap"
                          }}
                        >
                          <span
                            style={{
                              background: meal?.image
                                ? "rgba(255,255,255,0.16)"
                                : appTheme.softBackground,
                              padding: "7px 12px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              backdropFilter: "blur(6px)",
                              color: meal?.image ? "#ffffff" : appTheme.primaryText
                            }}
                          >
                            ⏱ {meal?.time ?? "—"} mins
                          </span>

                          <span
                            style={{
                              background: meal?.image
                                ? "rgba(255,255,255,0.16)"
                                : appTheme.softBackground,
                              padding: "7px 12px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              backdropFilter: "blur(6px)",
                              color: meal?.image ? "#ffffff" : appTheme.primaryText
                            }}
                          >
                            🔥 {meal?.calories ?? "—"} kcal
                          </span>

                          <span
                            style={{
                              background: meal?.image
                                ? "rgba(255,255,255,0.16)"
                                : appTheme.softBackground,
                              padding: "7px 12px",
                              borderRadius: "999px",
                              fontSize: "13px",
                              backdropFilter: "blur(6px)",
                              color: meal?.image ? "#ffffff" : appTheme.primaryText
                            }}
                          >
                            🍽 {meal?.servings ?? "—"} servings
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        padding: isMobile ? "14px 16px 18px" : "20px",
                        boxSizing: "border-box"
                      }}
                    >
                      {meal ? (
                        <>
                          <div
                            style={{
                              fontSize: "14px",
                              color: appTheme.secondaryText,
                              lineHeight: 1.6,
                              textAlign: "center",
                              marginBottom: "16px",
                              minHeight: isMobile ? "44px" : "48px"
                            }}
                          >
                            {meal.description || "No description added yet."}
                          </div>

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(3, 1fr)",
                              gap: "8px",
                              marginBottom: "16px"
                            }}
                          >
                            <div
                              style={{
                                padding: "12px",
                                borderRadius: "14px",
                                background: appTheme.softBackground,
                                border: appTheme.cardBorder,
                                textAlign: "center"
                              }}
                            >
                              <div style={{ fontSize: "12px", color: appTheme.secondaryText, marginBottom: "4px" }}>
                                Protein
                              </div>
                              <div style={{ fontSize: "18px", fontWeight: "700", color: appTheme.primaryText}}>
                                {meal?.macros?.protein || 0}g
                              </div>
                            </div>

                            <div
                              style={{
                                padding: "12px",
                                borderRadius: "14px",
                                background: appTheme.softBackground,
                                border: appTheme.cardBorder,
                                textAlign: "center"
                              }}
                            >
                              <div style={{ fontSize: "12px", color: appTheme.secondaryText, marginBottom: "4px" }}>
                                Carbs
                              </div>
                              <div style={{ fontSize: "18px", fontWeight: "700", color: appTheme.primaryText }}>
                                {meal?.macros?.carbs || 0}g
                              </div>
                            </div>

                            <div
                              style={{
                                padding: "12px",
                                borderRadius: "14px",
                                background: appTheme.softBackground,
                                border: appTheme.cardBorder,
                                textAlign: "center"
                              }}
                            >
                              <div style={{ fontSize: "12px", color: appTheme.secondaryText, marginBottom: "4px" }}>
                                Fats
                              </div>
                              <div style={{ fontSize: "18px", fontWeight: "700", color: appTheme.primaryText }}>
                                {meal?.macros?.fats || 0}g
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              padding: "16px",
                              borderRadius: "18px",
                              background: appTheme.softBackground,
                              border: appTheme.cardBorder,
                              marginBottom: "16px"
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "700",
                                color: appTheme.primaryText,
                                marginBottom: "10px",
                                textAlign: "center"
                              }}
                            >
                              Ingredients
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                                justifyContent: "center"
                              }}
                            >
                              {(meal.ingredients || []).map((ingredient, i) => (
                                <span
                                  key={i}
                                  style={{
                                    padding: "8px 10px",
                                    borderRadius: "999px",
                                    background: appTheme.cardBackground,
                                    border: appTheme.cardBorder,
                                    fontSize: "13px",
                                    color: appTheme.primaryText
                                  }}
                                >
                                  {ingredient}
                                </span>
                              ))}
                            </div>
                          </div>

                          <div
                            style={{
                              padding: "16px",
                              borderRadius: "18px",
                              background: appTheme.softBackground,
                              border: appTheme.cardBorder
                            }}
                          >
                            <div
                              style={{
                                fontWeight: "700",
                                color: appTheme.primaryText,
                                marginBottom: "10px",
                                textAlign: "center"
                              }}
                            >
                              Instructions
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                lineHeight: 1.7,
                                color: appTheme.secondaryText,
                                whiteSpace: "pre-line"
                              }}
                            >
                              {meal.instructions || "Add cooking steps here later."}
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          style={{
                            padding: "24px 20px",
                            borderRadius: "20px",
                            background: appTheme.softBackground,
                              border: appTheme.cardBorder,
                            textAlign: "center"
                          }}
                        >
                          <div
                            style={{
                              width: "64px",
                              height: "64px",
                              margin: "0 auto 14px",
                              borderRadius: "999px",
                              background: appTheme.accentLight,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "30px",
                              color: appTheme.accentColor
                            }}
                          >
                            +
                          </div>

                          <div
                            style={{
                              fontSize: "22px",
                              fontWeight: "500",
                              color: appTheme.primaryText,
                              marginBottom: "8px",
                              textTransform: "capitalize",
                              fontFamily: appTheme.fontHeading
                            }}
                          >
                            Add {mealType}
                          </div>

                          <div
                            style={{
                              fontSize: "14px",
                              color: appTheme.secondaryText,
                              marginBottom: "16px",
                              lineHeight: 1.6
                            }}
                          >
                            Head to the Plan tab to add a meal to this slot.
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px"
                            }}
                          >
                            <button
                              onMouseEnter={() => setHoveredButton(`empty-choose-${mealType}`)}
                              onMouseLeave={() => setHoveredButton(null)}
                              onClick={() => {
                                closeRecipeModal();
                                setActiveTab("plan");
                              }}
                              style={{
                                ...primaryButtonStyle(true, hoveredButton, `empty-choose-${mealType}`),
                                width: "100%",
                                borderRadius: "999px",
                                height: "48px"
                              }}
                            >
                              Go to Plan
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div
            style={{
              marginTop: "22px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: isMobile ? "0 16px 18px" : "0 20px 20px",
              gap: "10px"
            }}
          >
            {activeModalRecipe && activeModalMealType && (() => {
              const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
              const todayName = days[new Date().getDay()];
              const isToday = selectedHomeDay === todayName;
              const mealKey = `${selectedHomeDay}-${activeModalMealType}`;
              const isCooked = completedMeals?.[mealKey] || false;

              if (!isToday) return <div />;

              return (
                <button
                  onClick={() => completeMeal && completeMeal(selectedHomeDay, activeModalMealType)}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "999px",
                    border: isCooked
                      ? "1px solid rgba(134,239,172,0.7)"
                      : appTheme.accentBorder,
                    background: isCooked
                      ? "rgba(220,252,231,0.65)"
                      : appTheme.accentLight,
                    color: isCooked ? "#14532d" : appTheme.accentColor,
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.18s ease"
                  }}
                >
                  {isCooked ? "✓ Cooked" : "Mark as cooked"}
                </button>
              );
            })()}

            <button
              onMouseEnter={() => setHoveredButton("view-full")}
              onMouseLeave={() => setHoveredButton(null)}
              onClick={() => {
                setActiveTab("recipes");
                setSelectedHomeDay(null);
                setHomeMealIndex(0);
                setSelectedRecipe(activeModalRecipe || null);
              }}
              style={secondaryButtonStyle(appTheme, hoveredButton, "view-full")}
            >
              View in Recipes
            </button>
          </div>
        </div>

        {selectedHomeDay && orderedHomeMeals.length > 0 && (
          <div
            style={{
              marginTop: "12px",
              padding: "10px 14px",
              borderRadius: "999px",
              background: "rgba(255,255,255,0.16)",
              backdropFilter: "blur(18px) saturate(180%)",
              WebkitBackdropFilter: "blur(18px) saturate(180%)",
              border: "1px solid rgba(255,255,255,0.22)",
              boxShadow:
                "0 10px 24px rgba(15, 23, 42, 0.18), inset 0 1px 0 rgba(255,255,255,0.24)",
              display: "flex",
              justifyContent: "center",
              gap: "8px"
            }}
          >
            {orderedHomeMeals.map((item, index) => (
              <button
                key={`${selectedHomeDay}-${item.mealType}`}
                onClick={() => goToHomeViewerMeal(index)}
                aria-label={`Go to ${item.mealType}`}
                style={{
                  width: index === homeMealIndex ? "18px" : "8px",
                  height: "8px",
                  borderRadius: "999px",
                  border: "none",
                  background:
                    index === homeMealIndex
                      ? "rgba(255,255,255,0.95)"
                      : "rgba(255,255,255,0.34)",
                  cursor: "pointer",
                  transition: "all 0.22s ease",
                  boxShadow:
                    index === homeMealIndex
                      ? "0 4px 12px rgba(255,255,255,0.28)"
                      : "none"
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default HomeDayModal;